import { combineReducers } from 'redux';

import workflowReducer from './workflow/reducer';

const rootReducer = combineReducers({
  static: state => state || {},
  workflow: workflowReducer
});

export default rootReducer;
